// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1QWkX","footer":"ModalInfo_footer__3nOsp"};